module.exports = ".control-message__box {\n  font-size: 12px;\n  padding: 0.5em 0; }\n  .control-message__box .control-message__text {\n    color: #c44545; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/control-messages/control-messages.scss
// module id = yha1
// module chunks = 12